// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"350e124b","457":"f69e0005","582":"2c6a1522","641":"5876317f","648":"15b623c7","887":"084d0c36","905":"accf1864","955":"2aba1880"}[chunkId] + ".chunk.js";
};